import React, { useEffect, useRef, useState } from "react";
import { Html5Qrcode } from "html5-qrcode";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { useI18n } from "@/lib/i18n";

export default function QrScanner({ open, onOpenChange, onScan }) {
  const { t } = useI18n();
  const scannerRef = useRef(null);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!open) return;
    setError("");
    let scanner;
    const timer = setTimeout(async () => {
      try {
        scanner = new Html5Qrcode("qr-reader");
        scannerRef.current = scanner;
        await scanner.start(
          { facingMode: "environment" },
          { fps: 10, qrbox: { width: 220, height: 220 } },
          (text) => {
            onScan(text);
            onOpenChange(false);
          },
          () => {}
        );
      } catch (e) {
        setError(t("scan.cameraError"));
      }
    }, 300);
    return () => {
      clearTimeout(timer);
      if (scannerRef.current) {
        scannerRef.current.stop().then(() => scannerRef.current.clear()).catch(() => {});
        scannerRef.current = null;
      }
    };
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="qr-scanner-dialog">
        <DialogHeader><DialogTitle>{t("scan.title")}</DialogTitle><DialogDescription>{t("scan.hint")}</DialogDescription></DialogHeader>
        <div id="qr-reader" className="w-full overflow-hidden bg-black/90 min-h-[260px]" />
        {error && <p data-testid="qr-scanner-error" className="text-sm text-destructive">{error}</p>}
      </DialogContent>
    </Dialog>
  );
}
